// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"813c153c","453":"8e600158"}[chunkId] + ".chunk.js";
};